module.exports = __webpack_public_path__ + "static/media/upload_more.dadbfe05.svg";